import { TINTS } from "./demoContent";

const img = (n) => `/images/${n}.webp`;

export const aiChips = [
  { id: "interest", label: "Interest", detail: "Garba", color: "#7866E8" },
  { id: "time", label: "Time", detail: "This Saturday", color: "#80D9EB" },
  { id: "location", label: "Location", detail: "Nearby · 2 km", color: "#A5E6E3" },
  { id: "relationship", label: "Relationship", detail: "Close friends", color: "#A79DE2" },
  { id: "intent", label: "Intent", detail: "Open to plans", color: "#7398E7" },
  { id: "consent", label: "Consent", detail: "Required", color: "#D9A7E8", gate: true },
];

export const aiSteps = [
  { id: "karna", text: "Karna enjoys Garba.", avatars: ["karna"], range: [0.02, 0.08] },
  { id: "shashin", text: "Shashin enjoys Garba.", avatars: ["shashin"], range: [0.12, 0.18] },
  { id: "consent", text: "Both opted to share relevant nearby moments.", avatars: ["karna", "shashin"], range: [0.24, 0.3] },
];

export const aiRecommendation = {
  id: "ai-rec",
  image: img("feed-garba"),
  alt: "Karna's shared Garba night with friends dancing under string lights",
  tint: TINTS.lavender,
  source: "ai",
  title: "Karna's Garba Night",
  subtitle: "Shared with close friends",
  cta: "View Shared Moment",
  ctaStyle: "light",
  forWho: "For Shashin",
  headline: "Shashin may enjoy Karna's shared Garba moment.",
  reason: "Suggested because you share an interest in Garba and this moment was shared with you.",
  withdrawn: "No suggestion — Shashin hasn't opted in. Consent is required, not a factor.",
  preview: {
    id: "ai-rec-preview",
    image: img("feed-garba"),
    alt: "Karna's shared Garba night with friends dancing under string lights",
    category: "Shared Moment",
    source: "ai",
    title: "Karna's Garba Night",
    subtitle: "Navrang Grounds · shared with close friends",
    description: "Karna shared this moment with close friends. Your AI surfaced it because you both opted in to nearby Garba moments.",
    people: ["Karna", "Shashin", "Riya"],
    cta: "Reply to Karna",
    result: "Reply sent to Karna — sample demo",
  },
};

export const connectionPeople = [
  {
    id: "riya", name: "Riya", image: img("conn-riya"), avatar: img("avatar-riya"), tint: TINTS.pink,
    alt: "Riya smiling with headphones around her neck",
    bio: "Music · Design · Travel", stat: "3 shared interests", interests: ["Music", "Design", "Travel"],
    why: "You both saved indie gigs and a Lonavala trip this month.",
    cta: "Explore Connection", ctaKind: "propose", ctaStyle: "light",
    about: "Designer who plans trips around concerts. Always has a playlist for the train.",
    location: "Bandra West · 2 km away", mutuals: "Mutual friends: Shashin, Aditi",
    firstMessage: "Hi Riya! Our AI said we both love music…", reply: "Hey Karna! Indie and old Bollywood, always. You?",
  },
  {
    id: "dev", name: "Dev", image: img("conn-dev"), avatar: img("avatar-dev"), tint: TINTS.blue,
    alt: "Dev in round glasses holding a laptop",
    bio: "Startups · Technology", stat: "Interested in founder meetups", interests: ["Startups", "Product", "Travel tech"],
    why: "You're both building travel tools and going to Founders Circle.",
    cta: "Connect", ctaKind: "propose", ctaStyle: "dark",
    about: "Second-time founder working on group travel. Happy to trade notes over chai.",
    location: "BKC · 6 km away", mutuals: "Mutual friend: Aryan",
    firstMessage: "Hi Dev! Our AI said we're both building in travel tech…", reply: "Karna! Chai before Founders Circle on Thursday?",
  },
  {
    id: "meera", name: "Meera", image: img("conn-meera"), avatar: img("avatar-meera"), tint: TINTS.aqua,
    alt: "Meera holding a vintage film camera",
    bio: "Photography · Art", stat: "Looking for creative collaborations", interests: ["Film photography", "Art", "Zines"],
    why: "You both shoot on film and joined the Old City photo walk.",
    cta: "Say Hello", ctaKind: "propose", ctaStyle: "light",
    about: "Shoots street portraits on a 1970s camera. Building a small zine with friends.",
    location: "Colaba · 9 km away", mutuals: "Mutual friend: Kabir",
    firstMessage: "Hi Meera! Our AI said we both shoot on film…", reply: "Hi! Which camera? I'm on a Pentax K1000.",
  },
  {
    id: "aarav", name: "Aarav", image: img("conn-aarav"), avatar: img("avatar-aarav"), tint: TINTS.cyan,
    alt: "Aarav in a cycling jersey holding a helmet at dawn",
    bio: "Cycling · Outdoors", stat: "Interested in weekend rides", interests: ["Cycling", "Trekking", "Sunrises"],
    why: "You both ride on weekends and live 3 km apart.",
    cta: "View Profile", ctaKind: "profile", ctaStyle: "dark",
    about: "Product designer by week, cyclist by weekend. Always up for a sunrise ride and a long breakfast after.",
    location: "Khar · 3 km away", mutuals: "Mutual friends: Riya, Shashin",
    firstMessage: "Hi Aarav! Our AI said we both love weekend rides…", reply: "Hey! Joining the Sunday 6am loop?",
  },
];

export const personalFeatures = [
  { id: "remembers", title: "Remembers What Matters", body: "Your approved preferences, under your control." },
  { id: "finds", title: "Finds Opportunities", body: "Relevant people, plans and experiences." },
  { id: "acts", title: "Acts With Permission", body: "Your AI assists. You decide." },
];

export const agentConversation = [
  { id: 1, type: "user", text: "I want to meet people who love music this weekend." },
  { id: 2, type: "ai", text: "I found a few opt-in activities and people who share your interest." },
  {
    id: 3,
    type: "options",
    items: [
      {
        id: "meetup", title: "Live Music Meetup", meta: "Saturday evening", cta: "Explore", kind: "explore", image: img("feed-concert"),
        details: ["Saturday · 7:00 pm", "The Deck, Bandra", "8 opt-in attendees share your taste"],
      },
      { id: "community", title: "Creative Music Community", meta: "12 interested members", cta: "Join", kind: "join", image: img("feed-playlist") },
    ],
  },
  { id: 4, type: "user", text: "Invite someone to join me." },
  { id: 5, type: "ai", text: "Here's a draft invitation. Would you like me to send it?" },
  { id: 6, type: "invite", to: "Riya", avatar: img("avatar-riya"), text: "Hey Riya! There's a live music meetup this Saturday evening at The Deck. Want to come with me?" },
];

export const agentChips = [
  { id: "free", text: "Saturday evening is free", style: { left: "-96px", top: "24%" }, speed: [60, -80] },
  { id: "riya", text: "Riya also loves live music", avatar: img("avatar-riya"), style: { right: "-110px", top: "70%" }, speed: [120, -140] },
];
